import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'

const AutomationPopup = ({ body }) => {
  const { goBack } = useHistory()
  const { t } = useTranslation('map')

  return (
    <Popup>
      <div className='popup__infoBlocks'>
        <div className={`lockItem lockItem--info`}>
          <div><i className='icon icon--byapp'></i>{body.title} </div>
          <div dangerouslySetInnerHTML={{ __html: body.howTo }} ></div>
        </div>

        <ArrowBtn
          enlarged
          showArrow={false}
          text={t('IUnderstand')}
          action={goBack} />
      </div>
    </Popup>
  )
}

export default AutomationPopup